export default "__VITE_ASSET__CIFTykyW__"